// extracted by mini-css-extract-plugin
module.exports = {"bodyContainer":"linkWallet_bodyContainer__1ppl8"};